import { maskCurrencyInput } from '@/lib/mask'
import isEmpty from 'lodash/isEmpty'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'oz-buying-power-calculator',

  computed: {
    ...mapGetters({
      income: 'buyingPower/getIncome',
      downPayment: 'buyingPower/getDownPayment',
      buyingPowerData: 'buyingPower/getBuyingPowerData',
    }),

    incomeMasked: maskCurrencyInput('income'),
    downPaymentMasked: maskCurrencyInput('downPayment'),

    incomeModel: {
      get () { return this.incomeMasked },
      set (newValue) { this.setIncome(newValue) },
    },

    downPaymentModel: {
      get () { return this.downPaymentMasked },
      set (newValue) { this.setDownPayment(newValue) },
    },

    disableCalculateButton () {
      return isEmpty(this.incomeModel) || isEmpty(this.downPaymentModel)
    },
  },

  methods: {
    ...mapMutations({
      setIncome: 'buyingPower/setIncome',
      setDownPayment: 'buyingPower/setDownPayment',
      calculateBuyingPower: 'buyingPower/calculateBuyingPower',
    }),
    async calculate () {
      await this.calculateBuyingPower()
      this.loadPartnerData()
    },
    loadPartnerData () {
      this.$store.dispatch('partners/updatePartners', {
        brand: 'zap',
        listing: {
          type: 'vazio',
          price: this.buyingPowerData?.buyingPowerValue,
          address: {
            city: 'vazio',
            state: 'vazio',
          },
        },
      })
    },
  },
}
